import React from "react";
import { Col, Row } from "react-bootstrap";

import { Link } from "react-router-dom";
import { useHomeContext } from "../../provider/HomeProvider";
import SafariPackageCard from "components/safaripackages/view/SafariPackageCard";
import SafariPackageCardSkeleton from "components/common/Skeleton/packages/SafariPackageCardSkeleton";
import { common } from "Data/common";


function SafariPakageSection() {
  const { loading, safariPackages } = useHomeContext();

  const PACKAGE = common?.SAFARI_PACKAGE?.HOME;

  return (
    <>
      <section className="sharesafri">
        <div className="container-lg padditg_mobile">
          <Row className="justify-content-center">
            <Col xl={11} className="px-md-1 px-0">
              <div className="PackageBox_home p-sm-2 px-lg-5 py-md-4">
                <Row className="justify-content-left">
                  <Col xxl={12} lg={12} xl={12} className="pb-1">
                    <div className="title_safari JoinPadding d-flex justify-content-left justify-content-md-between align-items-left flex-wrap">
                      <h4 className="text-center" style={{ color: "#09422d" }}>
                        {PACKAGE?.BANNER}
                      </h4>
                      <div className="joinshareView mt-md-0 mt-3">
                        <Link to="/package" className="btn_shareView pakage">
                          {PACKAGE?.VIEW_ALL_BUTTON}
                        </Link>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row className="row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-2 row-cols-xl-3 row-cols-xxl-3 g-lg-3 gx-lg-4 gx-xxl-4">
                  {(Array.isArray(safariPackages) && safariPackages?.length > 0) ? (
                    safariPackages?.map((safariPackages) => (
                      <Col key={safariPackages.id} className="mb-lg-0 mb-3 padding_righ">
                        <SafariPackageCard safariPackages={safariPackages} />
                      </Col>
                    ))) : loading ? (
                      <>
                        <SafariPackageCardSkeleton count={3} />
                      </>
                    ) : (
                    <p>{PACKAGE?.NO_DATA}</p>
                  )}
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </section>
    </>
  );
}

export default SafariPakageSection;
